//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import MileElement from "@/components/shop/conf/MileElement.vue";
import ChevronUpIcon from "@/components/icons/ChevronUpIcon.vue";
import ChevronDownIcon from "@/components/icons/ChevronDownIcon.vue";

export default {
  components: {ChevronDownIcon, ChevronUpIcon, MileElement},
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    total: {
      type: String,
      default() {
        return '0'
      }
    },
    selected: {
      type: Object,
      default() {
        return {}
      }
    },
    stoneIndex: {
      type: Number,
      default() {
        return 0
      }
    },
    stoneTypes: {
      type: Array,
      default() {
        return []
      }
    },
    symbols: {
      type: Array,
      default() {
        return []
      }
    },
    stoneShapes: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      expansionPanels: this.stoneIndex,
      indexOfElements: null,
      margin: 0,
    }
  },
  watch: {
    expansionPanels(val) {
      if (val) {
        this.indexOfElements = false;
      }
    }
  },
  computed: {},
  methods: {
    indexChange(index, i) {
      let arr = this.$route.query.configId.split(',')[0].split('-');
      arr[i + 1] = arr[index + 1];
      arr[index + 1] = '';
      this.expansionPanels = null;
      const query = {...this.$route.query, configId: arr.join('-')};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query});
      }
      this.$nextTick(() => {
        window.scrollTo({top: 0});
      })
    },
    addAnElement() {
      let arr = this.$route.query.configId.split(',')[0].split('-');
      let first = arr.findIndex(item => item === "");
      arr[first] = 'RD' + this.stoneTypes[0][0].value;
      const query = {...this.$route.query, configId: arr.join('-')};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query});
      }
      this.expansionPanels = first - 1;
      this.$nextTick(() => {
        window.scrollTo({top: 0});
      })
    },
    changeST(item, i) {
      let arr = this.$route.query.configId.split(',')[0].split('-');
      let sizes = this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().ringSize || item.attribute_group === this.constAttributeGroups().necklaceSize).map(item => {
        return {...item, title: item.name}
      });
      let index = sizes.length ? 2 : 1;
      if (this.symbols.some(el => el.value === item.value)) {
        arr[i + 1] = item.value;
      } else {
        arr[i + 1] = 'RD';
        arr[i + 1] = arr[i + 1].substr(0, 2) + item.value;
      }
      const query = {...this.$route.query, configId: arr.join('-')};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query});
      }
    },
    changeSS(item) {
      let arr = this.$route.query.configId.split(',')[0].split('-');
      let sizes = this.info.attributes.filter(item => item.attribute_group === this.constAttributeGroups().ringSize || item.attribute_group === this.constAttributeGroups().necklaceSize).map(item => {
        return {...item, title: item.name}
      });
      let index = sizes.length ? 2 : 1;
      arr.forEach((it, i) => {
        if (i && i < (arr.length - index) && i === (this.stoneIndex + 1)) {
          if (arr[i].substr(0, 2) !== item.value) {
            arr[i] = item.value + arr[i].substr(2);
          }
        }
      })
      const query = {...this.$route.query, configId: arr.join('-')};
      if (this.$route.query.configId !== query) {
        this.$router.replace({query});
      }
    },
    back() {
      this.$parent.$emit('changeStage', 'configuration-edit')
    },
    close() {
      this.$parent.$emit('changeStage', 'configurator')
    },
    stringifyNumber(n) {
      const special = ['zeroth', 'first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth', 'eleventh', 'twelfth', 'thirteenth', 'fourteenth', 'fifteenth', 'sixteenth', 'seventeenth', 'eighteenth', 'nineteenth'];
      const deca = ['twent', 'thirt', 'fort', 'fift', 'sixt', 'sevent', 'eight', 'ninet'];
      if (n < 20) return special[n];
      if (n % 10 === 0) return deca[Math.floor(n / 10) - 2] + 'ieth';
      return deca[Math.floor(n / 10) - 2] + 'y-' + special[n % 10];
    },
  },
  mounted() {

  }
}
